import { red } from "@material-ui/core/colors"
import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles" {
  interface Palette {
    appContainerBackground: string
  }

  interface PaletteOptions {
    appContainerBackground: string
  }
}

const payAnyDayTheme = createMuiTheme({
  typography: {
    fontFamily: [
      "Gilroy",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#D6292E",
      dark: "#AE242F",
    },
    secondary: {
      main: "#F2E928",
      dark: "#1A1A18",
      light: "#f7f9fd",
    },
    error: {
      main: "#b11f24",
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#414042",
      secondary: "#000",
    },
    info: {
      main: "#F2E928",
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        borderRadius: "1px",
        padding: "15px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "12pt",
        width: "200px;",
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      },
      text: {
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "12pt",
      },
    },
  },
})

export default payAnyDayTheme
